import styled from "styled-components";
const CalendarBody = styled("div")({
  padding: 16
});
export {
  CalendarBody
};
